<!--<app-sidenav [collapsed]="sideNavVisible$ | async"></app-sidenav>-->
<div class="content flex">
  <p class="govuk-body-l">Your changes have been saved</p>
  <p><a class="navigation-text" [routerLink]="['/manage-org/profile']" [queryParams]="{isNewTab:true}">Return to 'Manage Organisation'</a></p>
</div>
